


export const filterBlock = (block, userVariablesGroupMap) => {
    const conditionalBlockTypes = ['conditionalMulti', 'conditional', 'conditionalCount', 'conditionalComplex']
    if (!conditionalBlockTypes.includes(block.data.type)) {
        return true;
    }

    // Conditional complex are a bit different. They use multiple variables potentially from different groups.
    if (block.data.type === 'conditionalComplex') {
        const conditions = block.data.conditions
        const globalOperator = block.data.operator
        const conditionsMet = []

        conditions.forEach(condition => {
            const groupId = condition.groupId;
            const variableId = condition.variableId;
            const value = condition.value;
            const operator = condition.operator;
            const userBlockValue = userVariablesGroupMap.get(`${groupId}-${variableId}`);

            let result;
            switch (operator) {
                case "==":
                    result = userBlockValue === value;
                    break;

                case "!=":
                    result = userBlockValue != value;
                    break;

                case "<=":
                    result = parseInt(userBlockValue) <= parseInt(value);
                    break;

                case ">=":
                    result = parseInt(userBlockValue) >= parseInt(value);
                    break;

                default:
                    result = false;
                    break;

            }

            conditionsMet.push(result)
        })

        switch (globalOperator.toLowerCase()) {
            case "and":
                return conditionsMet.every(e => e);

            case "or":
                return conditionsMet.some(e => e);

            default:
                return false;
        }
    }


    const groupId = block.data.groupId;
    const variableId = block.data.variableId;
    const value = block.data.value;
    const blockType = block.data.type;
    const userBlockValue = userVariablesGroupMap.get(`${groupId}-${variableId}`);

    if (blockType === 'conditionalCount') {
        if (typeof (userBlockValue) == "string") {
            return parseInt(userBlockValue) >= parseInt(value)
        }
        return false
    } else if (blockType === 'conditionalMulti') {
        return userBlockValue === value
    } else if (blockType === 'conditional') {
        return userBlockValue === value
    }
}
